module.exports = __webpack_public_path__ + "img/WalkIcon.c21ab89c.png";